import { connect } from 'react-redux';
import DuplicateModal from '../duplicate/DuplicateModal';
import { duplicateLightingSet } from '../../redux/luminaire/lightingset_actions';

const mapStateToProps = state => ({
  isDuplicating: state.lighting.lightingset.isDuplicating,
  errorMessage: state.lighting.lightingset.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateLightingSet(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);


// WEBPACK FOOTER //
// ./src/modal/lighting_set/LightingSetDuplicateModal.js